export default __webpack_public_path__ + "static/media/2102.c40d7e19.png";